import withNavigate from "../../../routes/withNavigate";
import GotraMasterContainer from "./GotraMasterContainer.jsx";
import GotraMasterStore from "./GotraMasterStore";

export default GotraMasterStore(withNavigate(GotraMasterContainer));